import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-route-reports-skeleton-loader',
  standalone: true,
  imports: [SkeletonModule, CommonModule],
  templateUrl: './route-reports-skeleton-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./route-reports-skeleton-loader.component.scss'],
})
export class RouteReportsSkeletonLoaderComponent {

}
